import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "player-nick text-center",
  style: {"cursor":"pointer"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "vs", -1)
const _hoisted_3 = {
  class: "player-nick text-center",
  style: {"cursor":"pointer"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "error"
}

import { ref, onMounted, computed } from "vue";
import { ViewPartidaTorneoDTO } from "@/interfaces/Partidas";
import { useRouter } from "vue-router";
import { formatFechaSpa } from "@/utils/Fecha";
import ModalDetallePartida from "@/components/PartidaAmistosa/ModalDetallePartida.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardPartidaTorneo',
  props: {
    match: {},
    idUsuario: {}
  },
  setup(__props: any) {

const isLoading = ref(true);
const error = ref<string | null>(null);
const router = useRouter();

const resultado = ref<string>("");
const fechaPartidaFormateada = ref<string>("");

const props = __props;

const showModalDetallePartida = ref(false);

const initializeComponent = async () => {
  try {
    isLoading.value = true;
    setResultado();
    fechaPartidaFormateada.value = await formatFechaSpa(
      props.match.fechaPartida
    );
  } catch (err) {
    error.value = (err as Error).message;
    router.push({ name: "error" });
  } finally {
    isLoading.value = false;
  }
};

const setResultado = () => {
  if (props.match.ganadorPartidaTorneo == null) {
    resultado.value = "Draw";
  } else if (props.match.ganadorPartidaTorneo == props.idUsuario) {
    resultado.value = "Win";
  } else {
    resultado.value = "Lose";
  }
};

const cardColorClass = computed(() => {
  switch (resultado.value) {
    case "Win":
      return "victoria-card";
    case "Lose":
      return "derrota-card";
    case "Draw":
      return "empate-card";
    default:
      return "";
  }
});

const verProfileUser = (idUser: number) => {
  router.push({ name: "detalle-jugador", params: { idUsuario: idUser } });
};

const goToDetallePartida = () => {
  showModalDetallePartida.value = true;
};

const closeModalDetallePartida = () => {
  showModalDetallePartida.value = false;
};

onMounted(initializeComponent);

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      ref: "matchCards",
      class: _normalizeClass(['match-card', cardColorClass.value]),
      style: _normalizeStyle({
      '--border-color':
        resultado.value === 'Win'
          ? '#145c1750'
          : resultado.value === 'Lose'
          ? '#75171050'
          : '#e6c40050',
    })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "text-center text-wrap text-h5" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.match.nombreTorneo), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_card_title, { class: "text-center text-wrap" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              justify: "center",
              class: "match-score",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (verProfileUser(_ctx.match.idUsuario1))),
                  cols: "5",
                  class: "player-name text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.match.nickUsuario1), 1),
                    _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.match.ejercitoUsuario1), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "score text-center marcador"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createElementVNode("p", null, _toDisplayString(_ctx.match.resultadoUsuario1) + "-" + _toDisplayString(_ctx.match.resultadoUsuario2), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (verProfileUser(_ctx.match.idUsuario2))),
                  cols: "5",
                  class: "player-name text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.match.nickUsuario2), 1),
                    _hoisted_4,
                    _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.match.ejercitoUsuario2), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_card_text, {
          class: _normalizeClass(['text-center', cardColorClass.value])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_chip, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(resultado.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.match.puntosPartida) + " pts ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "player-nick"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(fechaPartidaFormateada.value), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-3 match-scenario" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.match.escenarioPartida || "No disponible"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["class", "style"]),
    _createVNode(_component_v_spacer, { class: "my-3" }),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (showModalDetallePartida.value)
      ? (_openBlock(), _createBlock(ModalDetallePartida, {
          key: 1,
          partida: _ctx.match,
          onClose: closeModalDetallePartida
        }, null, 8, ["partida"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})